import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import editorConverters from '../../../services/editorConverters';
import ItemTypePickerItem from './ItemTypePickerItem';
import Icon from '../../Icon';
import TooltipContainer from '../../TooltipContainer';

class ConvertItemButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleItemClicked = this.handleItemClicked.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    handleItemClicked(item) {
        return this.setState({modal: false}, () => this.props.onConvert(item.type));
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {item} = this.props;
        if (!editorConverters[item.type]) {
            return null;
        }
        return (
            <TooltipContainer component="button" tooltip={messages.surveys.tooltips.convertItem}
                className="btn btn-link border-left" type="button" onClick={this.toggleModal}>
                <Icon icon="swap" />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="sm">
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.convert.title} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.convert.body} />
                        <div className="item-type-picker">
                            {Object.keys(editorConverters[item.type]).map((elem) =>
                                <ItemTypePickerItem key={elem} type={elem} onClick={this.handleItemClicked} />)}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                    </ModalFooter>
                </Modal>
            </TooltipContainer>
        );
    }
}

export default ConvertItemButton;
